module.exports = __webpack_public_path__ + "static/img/36-北京理工大学附属中学东校区.8c989b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/36-北京理工大学附属中学东校区.png
// module id = nn4C
// module chunks = 0